import Marquee from "react-fast-marquee";

// Slow editorial marquee (low contrast, widely tracked).
export default function EditorialMarquee({ items = [] }) {
  return (
    <div className="border-y border-border py-6 md:py-8 bg-surface overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {items.concat(items).map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl lg:text-4xl text-muted-foreground/80 px-8 md:px-12">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
